function initLottieOnScroll(id) {
  const player = document.getElementById(id)
  if (!player) return

  if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            player.play()
          }, 600)
        } else {
          player.stop()
        }
      })
    })
    observer.observe(player)
  } else {
    player.play()
  }
}

function initLottieOnce(id) {
  const player = document.getElementById(id)
  if (!player) return

  if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            player.play()
          }, 600)
          observer.unobserve(player)
        }
      })
    })
    observer.observe(player)
  } else {
    player.play()
  }
}

export default function initLottie() {
  initLottieOnScroll("investors-loop")
  initLottieOnce("anim-fund-survey-growth_story-mobile")
  initLottieOnce("anim-fund-survey-growth_story")
  initLottieOnce("anim-fund-survey-top_alocations-mobile")
  initLottieOnce("anim-fund-survey-top_alocations")
  initLottieOnce("anim-fund-survey-barrier-mobile")
  initLottieOnce("anim-fund-survey-barrier")
}
